import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Candidate, CandidateActionsInfo, Integration, User } from '../../../../shared/models';
import { SafeResourceUrl } from '@angular/platform-browser';
import { takeUntil } from 'rxjs/operators';
import { AccountService, UserService } from '../../../../shared/services';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-profile-export-actions',
  templateUrl: './profile-export-actions.component.html',
  styleUrls: ['./profile-export-actions.component.scss'],
  standalone: false,
})
export class ProfileExportActionsComponent implements OnInit, OnDestroy {
  private readonly accountService = inject(AccountService);

  @Input() profile: Candidate | null = null;
  @Input() actionsInfo: CandidateActionsInfo | null = null;
  @Input() image: SafeResourceUrl | string;
  @Input() folderId = '';
  @Input() isFullProfile = false;
  @Input() forSearchPage = false;
  @Input() limitAccess = false;
  @Input() columnStyle = false;
  @Input() profileHeader = false;

  @Output() profileAddedToCampaign = new EventEmitter<void>();

  private unsubscribe$ = new Subject<void>();

  protected readonly isLimited$ = this.accountService.isLimited$();

  isDownloadInProgress = false;
  isExportInProgress = false;
  withCsIntegration = false;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.currentUser$.pipe(takeUntil(this.unsubscribe$)).subscribe((user: User) => {
      const cleverStaffCredentials = user?.integrations.find(
        (integration: Integration) => integration.type === 'cleverstaff',
      );
      this.withCsIntegration = !!cleverStaffCredentials;
    });
  }

  onDownLoadInProgress(inProgress: boolean): void {
    this.isDownloadInProgress = inProgress;
  }

  onExportInProgress(inProgress: boolean): void {
    this.isExportInProgress = inProgress;
  }

  onProfileAddedToCampaign(): void {
    this.profileAddedToCampaign.emit();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
